/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AtlasOrganization } from '../models/AtlasOrganization';

export class DeactivateAtlasOrganizationResponse {
  'atlasOrganization': AtlasOrganization;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "atlasOrganization",
      "baseName": "atlasOrganization",
      "type": "AtlasOrganization",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DeactivateAtlasOrganizationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

